interface InviteParamsInput {
  pageSize: number;
  pageIndex: number;
  statusFilter: string;
  typeFilter?: string;
}

/**
 * Builds query params for GET /invites.
 * onlyEmailAndType:true bypasses the server-side businessID scoping so
 * admins can see all invites across all businesses.
 */
export function buildInviteParams(input: InviteParamsInput): Record<string, any> {
  const { pageSize, pageIndex, statusFilter, typeFilter } = input;
  const params: Record<string, any> = {
    limit: pageSize,
    page: pageIndex,
    onlyEmailAndType: true,
  };
  if (statusFilter !== 'all') params.status = statusFilter;
  if (typeFilter && typeFilter !== 'all') params.type = typeFilter;
  return params;
}
